import packageJson from "../../package.json";

/**
 * isExperimentationEnabled gates prototype features. The bare === against a
 * literal is deliberate: a wrapper like String().toLowerCase() would defeat
 * build-time constant folding, and the prototype chunks would stay in the
 * bundle even when the flag is off.
 */
export const isExperimentationEnabled =
  import.meta.env.VITE_ENABLE_EXPERIMENTATION === "true";

/**
 * isHideAdminPortalEnabled hard-hides Frontegg AdminPortal and enables in-app
 * Users/Groups settings nav. Bare === "true" matches the experimentation flag
 * so build-time folding can drop the portal path when the flag is on.
 */
export const isHideAdminPortalEnabled =
  import.meta.env.VITE_HIDE_ADMIN_PORTAL === "true";

/**
 * isHostedLoginEnabled switches login to Frontegg's hosted page. Locally the
 * embedded login box runs on a different origin than the app and trips
 * third-party cookie blocking, so local dev uses the hosted page; every other
 * env keeps the embedded box.
 */
export const isHostedLoginEnabled = import.meta.env.VITE_ENV === "local";

/**
 * isAssistantAutoSelectEnabled restores the last-used assistant (or the first
 * sidebar assistant) when /chat opens with no assistantId. On by default; set
 * VITE_AUTO_SELECT_ASSISTANT=false to keep the empty chat landing instead.
 * !== "false" so a missing key stays enabled (unlike opt-in === "true" flags).
 */
export const isAssistantAutoSelectEnabled =
  import.meta.env.VITE_AUTO_SELECT_ASSISTANT !== "false";

export const config = {
  key: packageJson.name,
  version: packageJson.version,
  chat: {
    pii: {
      debounceMs: Number(import.meta.env.VITE_CHAT_PII_DEBOUNCE_MS) || 500,
    },
    websocket: {
      // Closes tolerated before the error indicator takes over. At the 5s
      // retry interval that is roughly a 20s window, and the backend allows 20
      // simultaneous sockets per user, so the retries stay well inside it.
      maxDisconnections: 5,
    },
  },
  widget: {
    embedBaseUrl:
      import.meta.env.VITE_WIDGET_EMBED_URL || "https://widget.soulbyte.com",
  },
} as const;
